module.exports = __webpack_public_path__ + "img/netsoc-tacops.41fb5d51.jpg";